export const DOCUMENT_LABELS = [
  'CERTIFICADO',
  'CARTA CONSULAR',
  'ORDEN DE PAGO',
  'CONTRATO DE SERVICIOS',
  'CERTIFICADO MASCOTA',
];

export const DOCUMENT_DEFAULT_LANG = 'es';
